<template>
  <div class="sy-tax-rate">
    <el-select 
      v-model="code"
      :size="size"
      filterable 
      clearable
      v-bind="$attrs"
      v-on="$listeners"
      @change="selectChange"
    >
      <el-option class="sy-tax-select" v-for="tax in taxRateList" :label="tax.idNumber + '%' + ' / '+ tax.code" :value="tax.code" :key="tax.idNumber">
        <span class="option-tax">{{ tax.idNumber + '%' + ' / '+ tax.code }}</span>
        <span v-if="tax.description !== ''" class="option-tax tax-description">{{ tax.description }}</span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import Api from './api.js'
import response from '../../../utils/response'
import { componentMessage } from '../utils'
export default {
  props: {
    size: {
      type: String,
      default: 'small'
    },
    code: {
      type: [String, Array]
    }
  },
  data () {
    return {
      taxRateList: []
    }
  },
  watch: {
    code: {
      immediate: true,
      async handler (nVal, oVal) {
        this.$emit('update:code', nVal)
        if (!oVal && nVal) {
          this.checkCode()
        } else {
          this.$emit('validCode', false)
        }
      }
    }
  },
  methods: {
    async getTaxRate () {
      let api = Api.getTaxRate
      let res = await response(this.$http(api.type, `${api.url}`))
      if (res.isOk) {
        this.taxRateList = res.content || []
      }
    },
    // 校验禁用
    async checkCode () {
      let api = Api.validate
      let res = await response(this.$http(api.type, `${api.url}/${this.code}`))
      if (res.isOk) {
        this.$emit('validCode', res.content)
      }
    },
    selectChange (val) {
      let item = this.taxRateList.find(ele => ele.code === val) || {}
      item.idNumberPoint = item.idNumber / 100 ?? ''
      this.$emit('changeVal', val, item)
    }
  },
  created() {
    // 适用于商城端和采购商端
    let flag = componentMessage(['mall', 'purchaser', 'supplier'], 'tax-rate 税率')
    if (flag) return
    this.getTaxRate()
  }
}
</script>
<style lang="scss" scoped>
.sy-tax-select{
  .option-tax{
    display: block;
    line-height: 20px;
  }
  .tax-description{
    color: #909090;
    font-size: 13px;
    max-width: 350px;
  }
}
</style>